import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 p-4" }
const _hoisted_3 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", { class: "p-datatable-thead" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"7%"} }, "#"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }, "Created Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }, "Last Modified Date"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, "Version"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, "Sheets"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"10%"},
      class: "text-center"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"10%"},
      class: "text-center"
    }, "Action")
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "d-flex justify-content-center" }
const _hoisted_9 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)
const _hoisted_11 = { class: "d-flex justify-content-end p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: `Load ${_ctx.sheetType} Template Set`,
    visible: _ctx.visibleModel,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleModel) = $event)),
    draggable: false,
    style: { width: '60vw' },
    onHide: _ctx.onHide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          class: "p-button-text p-button-sm",
          label: "Cancel",
          icon: "pi pi-times",
          onClick: _ctx.onCancel
        }, null, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _hoisted_4,
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versions, (row, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: _ctx.rowKey(row),
                      style: {"cursor":"pointer"},
                      onClick: ($event: any) => (_ctx.onRowClick(row))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", null, _toDisplayString(row.createdDate), 1),
                      _createElementVNode("td", null, _toDisplayString(row.lastModifiedDate), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.displayDraftVersion(row)), 1),
                      _createElementVNode("td", null, _toDisplayString(row.sheetCount), 1),
                      _createElementVNode("td", _hoisted_7, [
                        _createVNode(_component_Badge, {
                          class: _normalizeClass(["mr-2", _ctx.statusBadgeClass(row.status)]),
                          value: row.status
                        }, null, 8, ["class", "value"])
                      ]),
                      _createElementVNode("td", {
                        class: "text-center",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_Button, {
                            icon: "pi pi-trash",
                            title: _ctx.isLoadedRow(row) ? 'Open in the editor - close it before deleting' : 'Delete',
                            severity: "danger",
                            text: "",
                            rounded: "",
                            disabled: _ctx.isLoadedRow(row),
                            onClick: ($event: any) => (_ctx.onDelete(row))
                          }, null, 8, ["title", "disabled", "onClick"])
                        ])
                      ])
                    ], 8, _hoisted_6))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (!_ctx.isLoading && !_ctx.versions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_FontAwesomeIcon, {
              icon: ['fas', 'image'],
              size: "2x"
            }),
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["header", "visible", "onHide"]))
}